import { Request, getParamsUrl } from '@/core'
import { control } from '@/constants/urls'

export default {
  get: params => Request.get(`${control.blacklist}${getParamsUrl(params)}`),
  create: data => Request.post(control.blacklistCreate, data),
  update: data => Request.post(control.blacklistUpdate, data),
  delete: id => Request.post(control.blacklistDelete, { id }),
}
